import React from 'react'
import { useTranslation } from 'react-i18next'
import { Text, StyleSheet, ScrollView, View } from 'react-native'
import { BackHeader } from '../../../../assets/icons'
import { GetIcon } from '../../../../ui/atoms/GetIcon'
import { HeaderButton, Toolbar } from '../../../../ui/molecules/Layout'
import Wrapper from '../../Wrapper'
import { Table } from './DesktopScreen'
import Button from '../../../IntegrationPayment/RegularIntegration/components/Button'
import { paths } from '../../../links'

export const ToolbarLeft = ({ navigation }) => {
  return (
    <HeaderButton
      icon={
        <GetIcon
          icon={<BackHeader height="20" width="20" />}
          onPress={() => navigation.goBack()}
        />
      }
    />
  )
}

export const MobileScreen = (props) => {
  const { t } = useTranslation('global')
  const { navigation, route } = props
  return (
    <Wrapper
      toolbar={
        <Toolbar
          headerStyle={{
            marginBottom: 0,
            borderBottomWidth: 1,
            borderBottomColor: '#E6EBEE',
          }}
          leftComponent={<ToolbarLeft navigation={navigation} />}
        />
      }
      footer={
        <View style={styles.buttonContainer}>
          <Button
            label={t('SelectProject.create-new-project')}
            onPress={() => {
              navigation.navigate(paths.Console.Payables.NewProject, {
                ids: route.params?.ids,
              })
            }}
            buttonStyle={styles.createProjectButton}
            textStyle={styles.createProjectButtonLabel}
          />
        </View>
      }
    >
      <Text style={styles.title}>{t('SelectProject.title-mobile')}</Text>
      <Text style={styles.subtitle}>{t('SelectProject.subtitle-mobile')}</Text>
      <ScrollView>
        <Table {...props} />
      </ScrollView>
    </Wrapper>
  )
}

const styles = StyleSheet.create({
  title: {
    marginTop: 16,
    fontWeight: '700',
    fontSize: 20,
    lineHeight: 28,
    marginBottom: 10,
  },
  subtitle: {
    fontWeight: '400',
    fontSize: 14,
    lineHeight: 20,
    marginBottom: 15,
    color: '#19262F',
  },
  link: {
    fontSize: 14,
    fontWeight: '600',
    lineHeight: 20,
    color: '#00A0F3',
    textDecorationLine: 'underline',
    marginBottom: 15,
  },
  buttonContainer: {
    paddingHorizontal: 20,
    width: '100%',
    shadowOffset: {
      width: 0,
      height: -4,
    },
    shadowOpacity: 0.06,
    shadowRadius: 12,
    elevation: 4,
  },
  createProjectButton: {
    backgroundColor: '#F8F9F9',
    marginVertical: 16,
  },
  createProjectButtonLabel: {
    color: '#001929',
    fontWeight: '700',
    fontSize: 16,
    lineHeight: 24,
    fontFamily: 'Inter',
  },
})
